import React from "react";
import { ArrowRight } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

const treatments = [
  {
    title: "Depressão",
    description: "Tratamento integrado com foco em recuperação emocional e funcional, com resgate do prazer de viver.",
  },
  {
    title: "Transtorno Bipolar",
    description: "Estabilização do humor e acompanhamento contínuo. Consultas individuais com psicoeducação e intervenção psicoterapêutica conforme necessário.",
  },
  {
    title: "Trauma e Estresse Pós-Traumático",
    description: "Técnicas avançadas (EMDR, Brainspotting) para reprocessar memórias e restaurar o equilíbrio emocional.",
  },
  {
    title: "Ansiedade, Transtorno Obsessivo Compulsivo e Fobias",
    description: "Redução de sintomas, compreensão das causas e fortalecimento de estratégias para lidar no dia a dia.",
  },
  {
    title: "Transtorno de Déficit de Atenção e Hiperatividade (TDAH)",
    description: "Organização do tratamento para melhorar foco, rotina e funcionamento no dia a dia.",
  },
  {
    title: "Dependência Química",
    description: "Acompanhamento clínico estruturado, com intervenções terapêuticas, para interrupção do uso e reorganização da vida.",
  },
];

export default function Treatments() {
  return (
    <section id="tratamentos" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <ScrollAnimation animation="fade-up">
          <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block">Tratamentos Oferecidos</span>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={100}>
          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-balance leading-tight">
            Tratamentos personalizados para diferentes demandas em saúde mental
          </h2>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={200}>
          <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a] mb-12 max-w-3xl">
            Na Mesquita Psiquiatria e Psicoterapia, oferecemos acompanhamento especializado para:
          </p>
        </ScrollAnimation>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {treatments.map((treatment, idx) => (
            <ScrollAnimation key={idx} animation="fade-up" delay={250 + idx * 100}>
              <div className="bg-gradient-to-br from-[#ACC996]/15 to-[#ACC996]/5 border border-[#ACC996]/30 rounded-2xl p-6 sm:p-8 h-full hover:shadow-xl hover:-translate-y-2 hover:border-[#ACC996]/50 transition-all duration-300 group">
                <div className="w-12 h-1 bg-[#C2A44A] rounded-full mb-5 group-hover:w-16 transition-all duration-300"></div>
                <h3 className="font-sans text-xl sm:text-2xl font-bold text-[#204613] mb-4 leading-tight">{treatment.title}</h3>
                <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a]">{treatment.description}</p>
              </div>
            </ScrollAnimation>
          ))}
        </div>

        <ScrollAnimation animation="fade-up" delay={600}>
          <div className="mt-10 sm:mt-12 bg-[#f5f0e4] border-l-4 border-[#C2A44A] rounded-xl p-5 sm:p-8">
            <p className="font-serif text-base sm:text-lg text-[#4a4a4a] leading-relaxed">
              Cada tratamento é construído junto com você, respeitando sua história, necessidades e objetivos.
            </p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animation="scale" delay={700}>
          <div className="mt-10 text-center">
            <a
              href="https://wa.me/5548992100333"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-[#204613] text-white rounded-xl font-sans font-semibold text-sm sm:text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Agendar Consulta
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
